// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1uAkN","overflowing":"ReadFullNote_overflowing__3xBVU"};